import { render, staticRenderFns } from "./VisualizacaoDpsIbsCbs.vue?vue&type=template&id=14615714&scoped=true&"
import script from "./VisualizacaoDpsIbsCbs.vue?vue&type=script&lang=js&"
export * from "./VisualizacaoDpsIbsCbs.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacaoDpsIbsCbs.vue?vue&type=style&index=0&id=14615714&scoped=true&lang=css&"
import style1 from "./VisualizacaoDpsIbsCbs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14615714",
  null
  
)

export default component.exports